module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    attrs: {
      "name": "addRace"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('span', [_c('p', {
    staticStyle: {
      "color": "red",
      "margin-bottom": "20px"
    }
  }, [_vm._v("Add Race")])]), _vm._v(" "), _c('div', {
    staticClass: "editFields"
  }, [_c('span', [_vm._v("Race Id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raceId),
      expression: "raceId"
    }],
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "number",
      "id": "newdistance",
      "name": "newdistance",
      "Placeholder": ""
    },
    domProps: {
      "value": (_vm.raceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.raceId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "editFields"
  }, [_vm._v("Distance "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newdistance),
      expression: "newdistance"
    }],
    staticStyle: {
      "width": "45%",
      "margin-left": "15px"
    },
    attrs: {
      "type": "number",
      "id": "newdistance",
      "name": "newdistance",
      "Placeholder": ""
    },
    domProps: {
      "value": (_vm.newdistance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newdistance = $event.target.value
      }
    }
  }), _vm._v(" Km")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error-msg"
  }, [_c('span', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Not a valid Race Id !")])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "float": "none"
    },
    on: {
      "click": function($event) {
        return _vm.Save(_vm.raceId, _vm.newdistance)
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-837aa63a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AddRaceData.vue
// module id = 1698
// module chunks = 2